import styles from "./style.module.scss";

export function classBest(i: number, best: number[] | undefined) {
  return best && best.includes(i) ? styles.best : "";
}
